module.exports = __webpack_public_path__ + "static/order-finished-img-eb239ab78ce97c05a4ffaa9a72739720.png";